import { io } from 'socket.io-client'

// "undefined" means the URL will be computed from the `window.location` object

const URL =
  process.env.NODE_ENV === 'production'
    ? 'wss://foodtollsindia.dev'
    : window.location.host.includes('localhost')
      ? 'http://localhost:3000'
      : window.location.host

export const socket = io({
  path: '/websocket/vendor/vendorws',
  autoConnect: false,
  withCredentials: true,
  reconnectionAttempts: 5,
  reconnectionDelay: 3000
})
